import { AxiosResponse } from 'axios';
import { ApiService } from 'common/services';
import { resolveApiBase } from 'common/utils/resolve-api-base';
import { ExportStatusResponse } from './export-data-api.types';

class ExportDataApiService extends ApiService {
  getExportStatus = (id: string): Promise<AxiosResponse<ExportStatusResponse>> => {
    return this.get(`/exports/${id}/status`);
  };
}

export const exportDataApi = new ExportDataApiService(resolveApiBase());
